export const config = {
    appname: 'bblprivilege',
    client_id: '1913492792231145', // App ID
    facebook_app_id: '1913492792231145', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'apibbl2',
    agency_id: '',
    bzbsUrlOldSupport: 'https://stg.buzzebees.com',
    bzbsUrl: 'https://apibbl2.buzzebees-uat.com',
    bzbsModuleUrl: 'https://bblmodule.buzzebees-uat.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule36.buzzebees-uat.com',
    webShoppingCartUrl: 'https://shoppingcartservice36.buzzebees-uat.com',
    bzbsBlobUrl: '	https://cdn.buzzebees-uat.com/th',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyD8Fj3Q1JXlMOfZKKOJpGAmyAMSu-Bpghc",
        authDomain: "bbl-redemption-stg.firebaseapp.com",
        projectId: "bbl-redemption-stg",
        storageBucket: "bbl-redemption-stg.appspot.com",
        messagingSenderId: "993767862488",
        appId: "1:993767862488:web:2e9e6e96b9c906d0ff67ad",
        measurementId: "G-LYVP5JXMW6"
    },
    gameLanding: "https://gamevue.buzzebees-uat.com"
};
